import Chart from 'react-apexcharts';

function LineChart({
  title = '',
  categories = [],
  series = [],
  width = '100%',
  height = 280,
  stroke = {},
  markers = {},
  decimalPoints = 0,
  suffix = '',
  yAxisDecimalPoints = 0,
  yAxisLabel = '',
}) {
  const options = {
    title: { text: title },
    chart: { animations: { enabled: false } },
    xaxis: {
      categories,
      labels: {
        offsetY: 5,
        rotate: -45,
        rotateAlways: true,
      },
    },
    yaxis: [
      {
        forceNiceScale: false,
        labels: {
          formatter(y) {
            return y != null
              ? `${new Intl.NumberFormat('en', {
                notation: 'compact',
                compactDisplay: 'short',
                minimumFractionDigits: 0,
                maximumFractionDigits: yAxisDecimalPoints,
              }).format(y)}${suffix}`
              : '';
          },
        },
        title: {
          text: yAxisLabel,
        },
      },
    ],
    grid: {
      padding: { left: 20 },
    },
    dataLabels: {
      enabled: false,
    },
    stroke,
    markers: {
      ...markers,
      hover: {
        size: 6,
      },
    },
    tooltip: {
      shared: false,
      intersect: true,
      y: {
        formatter(y) {
          return y != null
            ? `${new Intl.NumberFormat('en', {
              notation: 'compact',
              compactDisplay: 'short',
              minimumFractionDigits: 0,
              maximumFractionDigits: decimalPoints,
            }).format(y)}${suffix}`
            : '';
        },
      },
    },
  };

  return <Chart options={options} series={series} type="line" width={width} height={height} />;
}

export default LineChart;
